// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedViewPanel_root"};